import Vue from 'vue'
export default {
  success,
  info,
  error
}

function notify(text, type) {
  Vue.notify({ group: 'main', text: text, type: type, duration: 5000 })
}

function success(text) {
  notify(text, 'success')
}

function info(text) {
  notify(text, 'info')
}

function error(text, err) {
  notify(text, 'error')
  if (err) {
    console.log(err)
  }
}
